<template>
  <div class="header">
    <div class="head_top flex">
      <div class="head_top_left flex">
        <div class="logo">
          <a href="/"><img src="@/assets/img/logo.png" alt="" /></a>
        </div>
        <div class="search">
          <el-input
            v-model="searchtext"
            placeholder="请输入大学、专业"
            size="default"
            style="width: 370px"
            @keydown.enter.native="seachEnterFun"
          ></el-input>
          <span @click="tosearch"
            ><img src="@/assets/img/index (5).png" alt=""
          /></span>
        </div>
      </div>
      <!--      <div-->
      <!--        class="count-down"-->
      <!--        v-if="-->
      <!--          $store.state.userinfo &&-->
      <!--          showTime &&-->
      <!--          $store.state.userinfo.membershipType === '2'-->
      <!--        "-->
      <!--      >-->
      <!--        <div class="left">试用结束</div>-->
      <!--        <div class="count-time">{{ hour }}</div>-->
      <!--        <span>时</span>-->
      <!--        <div class="count-time">{{ minute }}</div>-->
      <!--        <span>分</span>-->
      <!--        <div class="count-time">{{ second }}</div>-->
      <!--        <span>秒</span>-->
      <!--      </div>-->
      <!--      <div class="vip" >-->
      <!--      </div>-->
      <div class="user">
        <span
          v-if="
            !$store.state.userinfo ||
            ($store.state.userinfo &&
              parseInt($store.state.userinfo.membershipType) === 0) ||
            parseInt($store.state.userinfo.membershipType) === 2
          "
          @click="toVip(true)"
          >开通VIP</span
        >
        <span
          v-if="
            $store.state.userinfo &&
            (parseInt($store.state.userinfo.membershipType) === 2 ||
              parseInt($store.state.userinfo.membershipType) === 0)
          "
          @click="toBindingCard(true)"
          >绑定VIP卡</span
        >
        <span v-if="!$store.state.userinfo" @click="tologin(true)">
          登录/注册
        </span>
        <div v-else class="userinfo flex">
          <div class="span flex">
            <span v-if="$store.state.userinfo.examType === '1'">普通高考</span>
            <span v-if="$store.state.userinfo.examType === '2'">艺术高考</span>
            <span v-if="$store.state.userinfo.examType === '3'">体育高考</span>
            <span v-if="$store.state.userinfo.examType === '4'">春季高考</span>
            <span>{{ $store.state.score }}分</span>
            <span>{{ $store.state.precedence }}位</span>
          </div>
          <i class="el-icon-edit" @click="edituser(true)"></i>
          <div class="head-css">
            <img :src="$store.state.userinfo.avatar" class="photo" />
            <img
              v-if="
                parseInt($store.state.userinfo.membershipType) === 1 ||
                parseInt($store.state.userinfo.membershipType) === 2
              "
              class="vipicon"
              src="@/assets/img/vip/hasvip.png"
              alt=""
            />
            <img
              v-if="parseInt($store.state.userinfo.membershipType) === 0"
              class="vipicon"
              src="@/assets/img/vip/novip.png"
              alt=""
            />
            <img
              v-if="
                parseInt($store.state.userinfo.membershipType) == 1 ||
                parseInt($store.state.userinfo.membershipType) === 2
              "
              class="vipicon"
              src="@/assets/img/vip/hasvip.png"
              alt=""
            />
            <img
              v-if="parseInt($store.state.userinfo.membershipType) == 0"
              class="vipicon"
              src="@/assets/img/vip/novip.png"
              alt=""
            />
            <div class="showmorecsssall">
              <div
                :class="[
                  parseInt($store.state.userinfo.membershipType) == 1
                    ? 'showmorecssscopy'
                    : 'showmorecsss',
                ]"
              >
                <div class="showmorecsss-top">
                  <div class="morehead">
                    <img :src="$store.state.userinfo.avatar" alt="" />
                    <img
                      v-if="
                        parseInt($store.state.userinfo.membershipType) == 1 ||
                        parseInt($store.state.userinfo.membershipType) == 2
                      "
                      class="vipicon"
                      src="@/assets/img/vip/hasvip.png"
                      alt=""
                    />
                    <img
                      v-if="parseInt($store.state.userinfo.membershipType) == 0"
                      class="vipicon"
                      src="@/assets/img/vip/novip.png"
                      alt=""
                    />
                  </div>
                  <div>
                    <div class="name">{{ $store.state.userinfo.name }}</div>
                    <div
                      class="tips"
                      v-if="parseInt($store.state.userinfo.membershipType) == 2"
                    >
                      有效期至{{ getPartTime($store.state.userinfo.dueTime) }}
                    </div>
                    <div
                      class="tips"
                      v-if="parseInt($store.state.userinfo.membershipType) == 0"
                    >
                      您还未开通会员
                    </div>
                  </div>
                </div>
                <!--                <div-->
                <!--                  v-if="-->
                <!--                    parseInt($store.state.userinfo.membershipType) == 1-->
                <!--                  "-->
                <!--                  class="novipcss"-->
                <!--                >-->
                <!--                  <img @click="toVip" src="@/assets/img/vip/vip.png" alt="" />-->
                <!--                </div>-->
                <div
                  @click="toPath('/mycenter/personalData')"
                  class="dropdown-text dropdown1"
                >
                  <img
                    class="dropdown-icon"
                    src="@/assets/img/vip/personal1.png"
                  />
                  <div class="text">个人资料</div>
                </div>
                <div
                  @click="toPath('/mycenter/myOrder')"
                  class="dropdown-text dropdown2"
                >
                  <img
                    class="dropdown-icon"
                    src="@/assets/img/vip/order1.png"
                  />
                  <div class="text">我的订单</div>
                </div>
                <div @click="toAgreement" class="dropdown-text dropdown3">
                  <img class="dropdown-icon" src="@/assets/img/vip/user1.png" />
                  <div class="text">用户协议</div>
                </div>
                <div @click="loginout" class="dropdown-text dropdown4">
                  <img class="dropdown-icon" src="@/assets/img/vip/out1.png" />
                  <div class="text">退出登录</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="head_nav flex">
      <div class="navlist flex">
        <div
          class="item"
          :class="{
            current: $route.path == item.path || $route.path == item.path2,
          }"
          v-for="(item, index) in navlist"
          :key="index"
          @click="tonav(item)"
        >
          <img
            v-if="item.name == '填志愿'"
            class="giflogo"
            src="@/assets/img/gif.gif"
            alt=""
          />
          <span>{{ item.name }}</span>
        </div>
      </div>
      <div class="countdown flex" v-if="countdownstate">
        距离{{ currentYear }}年高考还有<b>{{ countdown }}</b
        >天
      </div>
    </div>
    <el-dialog
      :visible.sync="$store.state.loginstate"
      width="830px"
      :show-close="false"
      custom-class="logindialog"
    >
      <logintem
        v-if="$store.state.loginstate"
        @getselective="getselective"
      ></logintem>
    </el-dialog>
    <!--    <el-dialog-->
    <!--      :visible.sync="$store.state.userstate"-->
    <!--      width="600px"-->
    <!--      :close-on-click-modal="userstate"-->
    <!--      :close-on-press-escape="userstate"-->
    <!--      :show-close="userstate"-->
    <!--    >-->
    <!--      <div slot="title" class="dialogtit"><b>请填写您的高考信息</b></div>-->
    <!--      <topinfo-->
    <!--        v-if="$store.state.userstate"-->
    <!--        @getselective="getselective"-->
    <!--      ></topinfo>-->
    <!--    </el-dialog>-->
    <vippayfor v-if="$store.state.memberstate"></vippayfor>
    <vip v-if="$store.state.vip"></vip>
    <cardbinding v-if="$store.state.bindingCard"></cardbinding>
  </div>
</template>

<script>
import { ajaxGetDictItems } from "@/api/api";
import logintem from "./login.vue";
import topinfo from "./topinfo.vue";
import vippayfor from "@/views/vipp/vipPay.vue";
import vip from "@/views/vipp/vip.vue";
import cardbinding from "@/views/vipp/cardBinding.vue";
export default {
  name: "index",
  inject: ["reload"],
  components: { logintem, topinfo, vippayfor, vip, cardbinding },
  mixins: [],
  data() {
    return {
      currentYear: "",
      countdownstate: false,
      userstate: false,
      countdown: 55,
      searchtext: "",
      userinfo: true,
      editstate: false,
      selective: "",
      navlist: [
        { name: "首页", path: "/homeindex" },
        { name: "填志愿", path: "/volunteer" },
        { name: "找学校", path: "/school", path2: "/school/detail" },
        { name: "选专业", path: "/specialty", path2: "/specialty/detail" },
        { name: "专家团队", path: "/expert" },
        {
          name: "高考资讯",
          path: "/information",
          path2: "/information/detail",
          path3: "/information/result",
          path4: "/information/list",
        },
      ],
      hour: "00",
      minute: "00",
      second: "00",
      time: null,
      showTime: true,
    };
  },
  watch: {
    $route(to, from) {
      if (from.path == "/search") {
        this.searchtext = "";
      }
    },
  },
  props: {},
  computed: {},
  created() {
    if (this.$store.state.token) {
      this.getselective();
    }
    if (
      localStorage.getItem("smstext") &&
      localStorage.getItem("smstext") > 0
    ) {
      let smstext = localStorage.getItem("smstext");
      let time = setInterval(() => {
        if (smstext > 0) {
          smstext--;
          localStorage.removeItem("smstext");
          localStorage.setItem("smstext", smstext);
        } else {
          clearInterval(time);
        }
      }, 1000);
    }
    if (this.$store.state.userinfo && !this.$store.state.userinfo.selective) {
      this.$store.commit("setuserstate", true);
    }
    this.setgkcountdown();
    this.setshowcountdown();
    this.getTimeString();
  },
  mounted() {},
  methods: {
    //设置规定时间内倒计时显示隐藏
    setshowcountdown() {
      let date = new Date();
      let currentTime = parseInt(date.getTime());
      let yyyy = date.getFullYear(); //年
      let gkstdate = new Date(`${yyyy}-06-07`).getTime();
      let gkendate = new Date(`${yyyy}-09-01`).getTime();
      //当前时间大于高考结束时间并且小于开学时间
      if (gkendate > currentTime > gkstdate) {
        this.countdownstate = false;
      }
      //当前时间小于高考结束时间或者大于开学时间
      if (currentTime < gkstdate || currentTime > gkendate) {
        this.countdownstate = true;
      }
    },
    //高考倒计时6.7日结束，9.1日之后显示下年倒计时
    setgkcountdown() {
      let date = new Date();
      let yyyy = date.getFullYear(); //年
      let m = date.getMonth() + 1; //月
      if (m >= 9) {
        yyyy += 1;
      }
      let gkdate = new Date(`${yyyy}-06-07`);
      let currentTime = parseInt(date.getTime()); //当前时间
      let gkTime = parseInt(gkdate.getTime()); //高考时间
      this.currentYear = yyyy;
      let remaining = gkTime - currentTime;
      this.countdown = Math.ceil(remaining / 1000 / 60 / 60 / 24);
    },
    getselective() {
      //格式化选科
      this.$store.dispatch("selectUserInfo").then((res) => {
        let data = this.$store.state.userinfo.selective;
        // console.log(data);
        if (!data) return false;
        let code = data.split(",");
        let arr = "";
        ajaxGetDictItems("choice_subject").then((res) => {
          let choiceSubject = res.result;
          choiceSubject.forEach((item) => {
            if (
              code[0] == item.value ||
              code[1] == item.value ||
              code[2] == item.value
            ) {
              arr += item.description;
            }
          });
          this.$store.commit("setSelective", arr.toString(" "));
        });
      });
    },
    tonav(item) {
      if (this.$route.path !== item.path) {
        if (item.path == "/volunteer") {
          let routeUrl = this.$router.resolve({
            path: item.path,
          });
          window.open(routeUrl.href, "_blank");
        } else {
          this.$router.push({
            path: item.path,
          });
        }
      }
    },
    tologin(state) {
      this.$store.commit("setloginstate", state);
    },
    edituser(state) {
      if (this.$store.state.userinfo.score) {
        this.userstate = true;
      } else {
        this.userstate = false;
      }
      if (this.$route.path !== "/mycenter/personalData")
        this.$router.push({
          path: "/mycenter/personalData",
        });
      this.$store.commit("setuserstate", state);
    },
    // 退出登录
    loginout() {
      this.$store.dispatch("loginout").then((res) => {
        console.log(res);
        if (res.success) {
          this.$message.success("退出成功");
          this.$store.dispatch("getAlreadyAsp");
          this.$router.push("/homeindex");
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 跳转个人中心指定页面
    toPath(url) {
      if (this.$route.path !== url) {
        this.$router.push({
          path: url,
        });
      }
    },
    // 用户协议
    toAgreement() {
      window.open(
        "https://aide-gaokao.oss-cn-hangzhou.aliyuncs.com/temp/%E7%94%A8%E6%88%B7%E5%8D%8F%E8%AE%AE.pdf"
      );
    },
    seachEnterFun(e) {
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13) {
        this.tosearch();
      }
    },
    tosearch() {
      if (!this.searchtext) {
        this.$message.error("请输入大学或专业名称");
        return false;
      }
      this.$store.commit("setsearchtext", this.searchtext);
      if (this.$route.path !== "/search") {
        this.$router.push({
          path: "/search",
        });
      }
    },
    // vip页面
    toVip(state) {
      if (this.$store.state.userinfo) {
        this.$store.commit("setmembertype", 0);
        this.$store.commit("setmemberstate", true);
      } else {
        this.$store.commit("setloginstate", state);
      }
    },

    toBindingCard(state) {
      if (this.$store.state.userinfo) {
        this.$store.commit("setBindingCardState", true);
      } else {
        this.$store.commit("setloginstate", state);
      }
    },
    // 获取当前时间戳
    getTimeString() {
      if (this.$store.state.token) {
        let time = this.$store.state.userinfo.memberTime;
        this.countDown(time);
      }
    },
    // 定时器
    // 页面多个倒计时 归零时清除
    countDown(time) {
      let that = this;
      if (new Date() > new Date(time)) {
        this.showTime = false;
        return false;
      }
      this.time = setInterval(() => {
        that.countDownFun(time);
      }, 1000);
    },
    countDownFun(time) {
      // console.log(time)
      let startTime = new Date(); //当前时间
      let end = new Date(time); //结束时间
      let result = parseInt((end - startTime) / 1000); //计算出毫秒
      this.hour = parseInt((result / (60 * 60)) % 24); //精确小时，用去余
      this.minute = parseInt((result / 60) % 60); //剩余分钟就是用1小时等于60分钟进行去余
      this.second = parseInt(result % 60);
      //当倒计时结束时，改变内容
      if (result <= 0) {
        clearInterval(this.time);
        this.showTime = false;
        this.$store.dispatch("selectUserInfo");
      }
      if (this.hour < 10) {
        this.hour = "0" + this.hour;
      }
      if (this.second < 10) {
        this.second = "0" + this.second;
      }
      if (this.minute < 10) {
        this.minute = "0" + this.minute;
      }
    },
    getPartTime(val) {
      if (this.$store.state.userinfo && val) {
        if (val.toString().indexOf("-") === -1) {
          var date = new Date(val);
          var year1 = date.getFullYear();
          var month1 = ("0" + (date.getMonth() + 1)).slice(-2); // getMonth() 是从0开始的，所以要+1
          var day1 = ("0" + date.getDate()).slice(-2);
          var hours = ("0" + date.getHours()).slice(-2);
          var minutes = ("0" + date.getMinutes()).slice(-2);
          var seconds = ("0" + date.getSeconds()).slice(-2);
          val =
            year1 +
            "-" +
            month1 +
            "-" +
            day1 +
            " " +
            hours +
            ":" +
            minutes +
            ":" +
            seconds;
        }
        let timearr = val.replace(" ", ":").replace(/:/g, "-").split("-");
        let year = Number(timearr[0]);
        let month = Number(timearr[1]);
        let day = Number(timearr[2]);
        if (month < 10) {
          month = "0" + month;
        }
        if (day < 10) {
          day = "0" + day;
        }
        var timestr = year + "-" + month + "-" + day;
        return timestr;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.header {
  width: 1200px;
  margin: 0 auto;
  padding: 20px 0;
  box-sizing: border-box;
  .head_top {
    .head_top_left {
      .logo {
        a {
          display: block;
        }
        img {
          display: block;
          width: 80px;
        }
      }
      .search {
        margin-left: 70px;
        position: relative;
        display: flex;
        align-items: center;
        /deep/ .el-input__inner {
          border-color: #660874;
        }
        span {
          position: absolute;
          right: 10px;
          font-size: 22px;
          color: #660874;
          cursor: pointer;
        }
      }
    }
    .count-down {
      width: 250px;
      background: #fff5f2;
      border-radius: 8px;
      margin-left: 20px;
      box-sizing: border-box;
      padding: 10px 13px;
      font-size: 12px;
      color: #660874;
      display: flex;
      align-items: center;
      .count-time {
        width: 22px;
        height: 20px;
        line-height: 20px;
        text-align: center;
        background: #660874;
        border-radius: 2px;
        font-size: 14px;
        color: #ffffff;
        margin: 0px 10px;
      }
    }
    .vip {
      margin-left: 380px;
      display: block;
      width: 100px;
      height: 45px;
      background: #660874;
      border-radius: 8px;
      text-align: center;
      line-height: 45px;
      color: #fff;
      cursor: pointer;
    }
    .user {
      display: flex;
      flex-direction: row;
      > span {
        display: block;
        width: 90px;
        height: 45px;
        background: linear-gradient(270deg, #660874, #8a2be2, #c17eeb);
        border-radius: 8px;
        text-align: center;
        line-height: 45px;
        color: #fff;
        cursor: pointer;
        margin-left: 20px;
      }
      .userinfo {
        justify-content: flex-end;
        align-items: center;
        .flex {
          margin-left: 15px;
        }
        .span {
          > span {
            font-size: 16px;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            &::before {
              content: "";
              display: block;
              width: 1px;
              height: 15px;
              background-color: #333;
              margin: 0 10px;
            }
            &:first-child {
              &::before {
                display: none;
              }
            }
          }
        }

        i {
          margin-left: 10px;
          cursor: pointer;
          font-size: 20px;
          color: #660874;
          font-weight: 700;
        }
        .head-css {
          position: relative;
          .photo {
            width: 56px;
            height: 56px;
            margin-left: 10px;
            cursor: pointer;
            border-radius: 50%;
          }
          .vipicon {
            position: absolute;
            top: 0;
            right: -5px;
          }
          .showmorecsssall {
            position: absolute;
            top: 56px;
            right: 0;
            padding-top: 20px;
            z-index: 99;
          }
          .showmorecsss,
          .showmorecssscopy {
            width: 250px;
            height: 0px;
            background: #ffffff;
            box-shadow: 0px 0px 20px 0px rgba(102, 102, 102, 0.35);
            transition: all 0.5s;
            border-radius: 8px;
            overflow: hidden;
            .showmorecsss-top {
              width: 100%;
              height: 96px;
              background: #f7f7f9;
              box-sizing: border-box;
              padding: 20px 10px 20px 20px;
              display: flex;
              .morehead {
                width: 56px;
                height: 56px;
                margin-right: 20px;
                position: relative;
                img {
                  width: 56px;
                  height: 56px;
                }
                .vipicon {
                  width: 23px;
                  height: 15px;
                  position: absolute;
                  top: 0;
                  right: -5px;
                }
              }
              .name {
                font-size: 20px;
                color: #000000;
                margin-bottom: 5px;
                display: -webkit-box;
                -webkit-line-clamp: 1;
                -webkit-box-orient: vertical;
                overflow: hidden;
                text-overflow: ellipsis;
              }
              .tips {
                font-size: 14px;
                color: #999999;
              }
            }
            .novipcss {
              padding: 20px 57px;
              border-bottom: 1px solid #f7f7f9;
              margin-bottom: 10px;
              img {
                &:hover {
                  cursor: pointer;
                }
              }
            }
            .dropdown-text {
              display: flex;
              align-items: center;
              padding: 14px 22px;
              font-size: 16px;
              color: #666666;
              .dropdown-icon {
                margin-right: 20px;
              }
              &:hover {
                cursor: pointer;
                background: #660874;
                color: #ffffff;
              }
            }
            .dropdown1 {
              &:hover {
                .dropdown-icon {
                  content: url("../../assets/img/vip/personal2.png");
                }
              }
            }
            .dropdown2 {
              &:hover {
                .dropdown-icon {
                  content: url("../../assets/img/vip/order2.png");
                }
              }
            }
            .dropdown3 {
              &:hover {
                .dropdown-icon {
                  content: url("../../assets/img/vip/user2.png");
                }
              }
            }
            .dropdown4 {
              &:hover {
                .dropdown-icon {
                  content: url("../../assets/img/vip/out2.png");
                }
              }
            }
          }
          &:hover {
            .showmorecsss {
              height: 430px;
            }
            .showmorecssscopy {
              height: 320px;
            }
          }
        }
      }
    }
  }
  .head_nav {
    width: 1100px;
    margin: 0 auto;
    margin-top: 20px;
    .navlist {
      width: 700px;
      .item {
        font-size: 20px;
        font-weight: bold;
        cursor: pointer;
        position: relative;
        .giflogo {
          position: absolute;
          top: -10px;
          left: -25px;
          width: 35px;
          height: 28px;
          transform: rotate(-20deg);
        }
        &:hover {
          color: #660874;
        }
      }
      .current {
        color: #660874;
      }
    }
    .countdown {
      justify-content: flex-end;
      font-size: 16px;
      color: #999;
      b {
        display: block;
        width: 47px;
        height: 43px;
        margin: 0 10px;
        line-height: 43px;
        text-align: center;
        color: #660874;
        font-size: 24px;
        //background: url("../../assets/img/index (3).png");
      }
    }
  }
}
/deep/ .logindialog {
  border-radius: 8px;
  .el-dialog__header {
    display: none;
  }
  .el-dialog__body {
    padding: 0;
  }
}
.dialogtit {
  b {
    font-size: 20px;
  }
}
</style>
